import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'paymentDateTextColor'
})

export class PaymentDateTextColorPipe implements PipeTransform {
    transform(value: any): string {
        if (!moment(value).isValid()) {
            return;
        }
        const daysSinceLastPayment = moment().endOf('day').diff(moment(value).endOf('day'), 'days');
        return daysSinceLastPayment <= 90 ? '#008000' : daysSinceLastPayment > 90 && daysSinceLastPayment <= 180 ? '#ffb347' : '#FF0000';
    }

}
